import { Reveal, Eyebrow } from "@/components/Reveal";

const ROLES = [
  "Nauczycielka języka angielskiego",
  "Trenerka nauczycieli",
  "Metodyczka",
  "Ekspertka w edukacji",
  "Właścicielka kilku biznesów edukacyjnych",
];

export const About = () => (
  <section id="o-luizie" data-testid="about-section" className="bg-alabaster py-20 sm:py-28">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
        <Reveal className="relative lg:col-span-5">
          <div className="absolute -left-4 top-8 hidden h-[70%] w-[55%] bg-red sm:block" aria-hidden="true" />
          <figure className="relative ml-auto aspect-[4/5] w-[88%] overflow-hidden bg-white">
            <img
              src="/photos/luiza-laptop.webp"
              alt="Luiza Wójtowicz-Waga pracująca na laptopie"
              loading="lazy"
              className="h-full w-full object-cover object-top"
            />
          </figure>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7">
          <Eyebrow>Dlaczego ta biblioteka</Eyebrow>
          <h2 className="font-display mt-5 text-4xl font-medium leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl">
            Pracuję po obu stronach biurka
          </h2>
          <p className="mt-6 text-base leading-relaxed text-ink/70 sm:text-lg">
            Nazywam się Luiza Wójtowicz-Waga. Uczę angielskiego, szkolę nauczycieli i prowadzę własną działalność
            językową. Znam codzienność lekcji i codzienność gabinetu właścicielki: hospitacje, sekretariat, rodziców,
            firmy, plan na rok szkolny. Każdy produkt w tej bibliotece powstał z mojej praktyki.
          </p>
          <ul className="mt-8 grid grid-cols-1 gap-x-8 gap-y-3 border-t border-ink/15 pt-6 sm:grid-cols-2">
            {ROLES.map((r) => (
              <li key={r} className="flex items-center gap-3 text-[15px] text-ink/80">
                <span className="h-1.5 w-1.5 bg-red" />
                {r}
              </li>
            ))}
          </ul>
          <a
            href="https://luizawojtowiczwaga.com/omnie/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-more-link"
            className="mt-8 inline-block text-[13px] font-semibold text-ink underline underline-offset-4 hover:text-red"
          >
            Więcej o mnie na luizawojtowiczwaga.com
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
